<app-modal
  [isOpen]="isOpen"
  title="비밀번호 변경"
  description="안전한 계정 관리를 위해 현재 비밀번호와 새로운 비밀번호를 입력해주세요."
  maxWidth="460px"
  iconType="cyan"
  (close)="onCloseModal()">

  <div modal-header-icon>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" width="20" height="20">
      <path stroke-linecap="round" stroke-linejoin="round" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
    </svg>
  </div>

  <div class="change-password-content">
    @if (successMessage()) {
      <div class="alert-success">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" class="alert-icon">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        <span>{{ successMessage() }}</span>
      </div>
    }

    @if (errorMessage()) {
      <div class="alert-danger">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" class="alert-icon">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
        </svg>
        <span>{{ errorMessage() }}</span>
      </div>
    }

    <form id="change-password-form" (ngSubmit)="onSubmit()" class="modal-form">
      <!-- 현재 비밀번호 -->
      <div class="form-group">
        <label for="current-password">현재 비밀번호</label>
        <div class="input-with-toggle">
          <input
            [type]="showCurrentPassword() ? 'text' : 'password'"
            id="current-password"
            name="currentPassword"
            class="form-input"
            [ngModel]="currentPassword()"
            (ngModelChange)="currentPassword.set($event)"
            placeholder="현재 비밀번호 입력"
            required
            [disabled]="isLoading()"
          />
          <button
            type="button"
            class="btn-toggle-visibility"
            (click)="toggleShowCurrentPassword()"
            tabindex="-1"
            [attr.aria-label]="showCurrentPassword() ? '비밀번호 숨기기' : '비밀번호 보기'"
          >
            @if (showCurrentPassword()) {
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" class="icon-sm">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858-5.908a10.048 10.048 0 013.682-.763c4.478 0 8.268 2.943 9.542 7a10.025 10.025 0 01-4.132 5.411m-4.592-4.592a3 3 0 11-4.243-4.243" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M3 3l18 18" />
              </svg>
            } @else {
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" class="icon-sm">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            }
          </button>
        </div>
      </div>

      <!-- 새 비밀번호 -->
      <div class="form-group">
        <label for="new-password">새 비밀번호</label>
        <div class="input-with-toggle">
          <input
            [type]="showNewPassword() ? 'text' : 'password'"
            id="new-password"
            name="newPassword"
            class="form-input"
            [class.input-error]="isSameAsCurrent() || (newPassword().length > 0 && !isMinLengthValid())"
            [ngModel]="newPassword()"
            (ngModelChange)="newPassword.set($event)"
            placeholder="새 비밀번호 입력 (최소 6자)"
            required
            [disabled]="isLoading()"
          />
          <button
            type="button"
            class="btn-toggle-visibility"
            (click)="toggleShowNewPassword()"
            tabindex="-1"
            [attr.aria-label]="showNewPassword() ? '비밀번호 숨기기' : '비밀번호 보기'"
          >
            @if (showNewPassword()) {
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" class="icon-sm">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858-5.908a10.048 10.048 0 013.682-.763c4.478 0 8.268 2.943 9.542 7a10.025 10.025 0 01-4.132 5.411m-4.592-4.592a3 3 0 11-4.243-4.243" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M3 3l18 18" />
              </svg>
            } @else {
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" class="icon-sm">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            }
          </button>
        </div>
        @if (newPassword().length > 0 && !isMinLengthValid()) {
          <span class="field-error-msg">비밀번호는 최소 6자 이상이어야 합니다.</span>
        }
        @if (isSameAsCurrent()) {
          <span class="field-error-msg">새 비밀번호는 현재 비밀번호와 달라야 합니다.</span>
        }
      </div>

      <!-- 새 비밀번호 확인 -->
      <div class="form-group">
        <label for="confirm-password">새 비밀번호 확인</label>
        <div class="input-with-toggle">
          <input
            [type]="showConfirmPassword() ? 'text' : 'password'"
            id="confirm-password"
            name="confirmPassword"
            class="form-input"
            [class.input-error]="confirmPassword().length > 0 && !isPasswordMatching()"
            [ngModel]="confirmPassword()"
            (ngModelChange)="confirmPassword.set($event)"
            placeholder="새 비밀번호 다시 입력"
            required
            [disabled]="isLoading()"
          />
          <button
            type="button"
            class="btn-toggle-visibility"
            (click)="toggleShowConfirmPassword()"
            tabindex="-1"
            [attr.aria-label]="showConfirmPassword() ? '비밀번호 숨기기' : '비밀번호 보기'"
          >
            @if (showConfirmPassword()) {
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" class="icon-sm">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858-5.908a10.048 10.048 0 013.682-.763c4.478 0 8.268 2.943 9.542 7a10.025 10.025 0 01-4.132 5.411m-4.592-4.592a3 3 0 11-4.243-4.243" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M3 3l18 18" />
              </svg>
            } @else {
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" class="icon-sm">
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
              </svg>
            }
          </button>
        </div>
        @if (confirmPassword().length > 0 && !isPasswordMatching()) {
          <span class="field-error-msg">새 비밀번호가 일치하지 않습니다.</span>
        }
      </div>
    </form>
  </div>

  <div modal-footer class="change-password-actions">
    <button type="button" (click)="onCloseModal()" class="btn-secondary" [disabled]="isLoading()">취소</button>
    <button type="submit" form="change-password-form" class="btn-primary" [disabled]="!isFormValid() || isLoading()">
      @if (isLoading()) {
        <span class="spinner-sm"></span>
        <span>변경 중...</span>
      } @else {
        <span>비밀번호 변경</span>
      }
    </button>
  </div>
</app-modal>
